<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row column-align="center" col-spaced>
          <grid-col col-size="4">
            <div class="header-wrapper margin-top-xl">
              <div class="title-wrapper">
                <h1 class="header header-title">
                  {{ $t('menu.explorer') }}
                </h1>
                <h2>{{ $t('explore.title') }}</h2>
              </div>
            </div>
          </grid-col>
        </grid-row>
          <grid-row column-align="center" class="margin-top-xxl">
            <grid-col col-size="4">
              <div class="center-horizontal">
                <!-- Evolution -->
                <safe-router-link to="/explorer-evolution-variables">
                  <div v-has-feature="'Explore'" class="personal-area-element">
                    <icon-evolution class="personal-area-element-icon" />
                    <div class="personal-area-element-title">{{ $t('explorer.menu.evolution.label') }}</div>
                  </div>
                </safe-router-link>

                <!-- Correlation -->
                <span v-if="!isSuperAdmin()">
                  <safe-router-link to="/explorer-correlation-variables" class="nav__menu-item">
                    <div v-has-feature="'Explore'" class="personal-area-element">
                      <icon-correlations class="personal-area-element-icon" />
                      <div class="personal-area-element-title">{{ $t('menu.correlation') }}</div>
                    </div>
                  </safe-router-link>
                </span>

                <!-- Correlation Menu-->
                <span v-has-feature="'ExplorerCorrelationBenchmark'">
                  <safe-router-link to="/explorer-correlation/menu" class="nav__menu-item">
                    <div v-has-feature="'Explore'" class="personal-area-element">
                      <icon-correlations class="personal-area-element-icon" />
                      <div class="personal-area-element-title">{{ $t('menu.correlation') }}</div>
                    </div>
                  </safe-router-link>
                </span>
              </div>
            </grid-col>
          </grid-row>
      </div>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '../MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import SafeRouterLink from '@/components/shared/SafeRouterLink';
import IconEvolution from '@/components/shared/icons/IconEvolution';
import IconCorrelations from '@/components/shared/icons/IconCorrelations';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faBalanceScaleLeft} from '@fortawesome/pro-light-svg-icons';
import {mapGetters} from 'vuex';

export default {
  name: 'Explore',
  components: {
    SafeRouterLink,
    MainLayout,
    GridRow,
    GridCol,
    IconEvolution,
    IconCorrelations,
    FontAwesomeIcon
  },
  data () {
    return {
      icon: {
        multipleCorrelation: faBalanceScaleLeft
      }
    };
  },
  computed: {
    ...mapGetters([
      'getUserAccount'
    ]),
    getBreadcrumb () {
      const self = this.$t('menu.explorer');
      return [
        {name: self, link: '/explore', disabled: true}
      ];
    }
  },
  methods: {
    isSuperAdmin () {
      return this.getUserAccount &&
        this.getUserAccount.authorities &&
        this.getUserAccount.authorities.includes('ROLE_SUPERADMIN');
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "src/stylesheets/variables";

  .header-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .title-wrapper {
    display: flex;
  }

  h1 {
    margin-right: $sp-margin;
    padding-right: $sp-margin;
    border-right: 1px solid $black-trans6;
  }

  h2 {
    line-height: 2.2;
    font-size: 1.2rem;
    font-weight: lighter;
  }

  .personal-area-element {
    align-items: center;
    display: inline-block;
    text-align: center;
    background-color: $black-light9;
    border: solid 0.2rem $black-light9;
    border-radius: $radius;
    height: 15rem;
    width: 15rem;
    color: $secondary;
    margin: 1rem;
    padding-top: 2.7rem;
  }

  .personal-area-element:hover {
    border: solid 0.2rem $black-light5;
  }

  .personal-area-element-icon {
    width: 7rem;
    color: $secondary;
  }

  .personal-area-element-font-icon {
    font-size: 7rem;
    width: 7rem;
    color: $secondary;
  }

  .personal-area-element-title {
    font-size: 1.3rem;
    font-weight: bold;
  }

  .disabled, .disabled:hover{
    color: $secondary-trans7;
    border: solid 0.2rem $black-light9;
  }

  .center-horizontal {
    display: table;
    margin: 0 auto;
  }

</style>



// WEBPACK FOOTER //
// src/layouts/explorer/Explore.vue